var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_c('b-button',{staticClass:"btn-add-something",attrs:{"variant":"light"},on:{"click":_vm.onClickButton}},[_c('i',{staticClass:"bi bi-image"}),_vm._v(" "+_vm._s(_vm.placeholder)+" ")]),_c('input',{ref:"inputFile",attrs:{"type":"file","hidden":"","accept":"image/*"},on:{"change":_vm.onInputChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }